//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        collName: String,
        columnDefs: Array,
        detailTitleFn: [String, Function],
        validateFn: Function,
        postSaveFn: Function,
        newTitleVariantFn: [String, Function],
        ops: {
            type: String,
            default: 'add,archive,detail',
        },
        filterFn: Function,
        textFilterFn: [String, Function],
        hideActiveToggle: Boolean,
        hidePagination: Boolean,
        detailAutoHeight: Boolean,
        detailLeftTabs: Boolean,
    },

    data() {
        return {
            canCloseDetail: false,
            isDetailDirty: false,
            showActive: this.collName === 'claims' ? 1 : true,
            filterText: '',
        };
    },

    computed: {
        masterBlockSlots() {
            return _.pickBy(this.$scopedSlots, (_, slot) => slot.startsWith('field-') || slot.startsWith('body-cell-'));
        },
        processedOps() {
            return ($.canDestroy && this.ops.includes('archive')) ? `${this.ops},destroy` : this.ops;
        },
        archivedFilter() {
            if (this.collName === 'claims')
                return i => i.state === this.showActive;

            switch (this.showActive) {
                case true:  return i => !i.archived;
                case false: return i => i.archived;
                default:    return null;
            }
        },
        finalTextFilter() {
            if (!this.textFilterFn)
                return null;

            if (typeof this.textFilterFn === 'function')
                return this.textFilterFn;

            // Comma-separated field paths
            // May include space-separated paths for fields to be space-joined for purposes of filtering

            return (item, text) => $.filterByCsvFieldPaths(item, this.textFilterFn, text);
        },
        isDetailOpen: {
            get() { return this.$route.params.id != null; },
            set() {
                if (this.canCloseDetail && this.isDetailOpen) {
                    $.goToMaster();
                }
            },
        },
        showActiveOptions() {
            if (this.collName === 'claims') {
                return [{
                    value: 1,
                    label: 'Kompletní',
                }, {
                    value: 0,
                    label: 'Nekompletní',
                }, {
                    value: 2,
                    label: 'Vyřešené',
                }];
            }

            return [{
                value: true,
                label: 'Aktivní',
            }, {
                value: false,
                label: (
                    this.collName === 'vehicles' ? 'Archivovaná' :
                    ['clients', 'users'].includes(this.collName) ? 'Archivovaní' :
                    'Archivované'
                ),
            }, {
                value: null,
                label: (
                    this.collName === 'vehicles' ? 'Všechna' :
                    ['clients', 'users'].includes(this.collName) ? 'Všichni' :
                    'Všechny'
                ),
            }];
        },
    },

    watch: {
        isDetailOpen() {
            this.isDetailDirty = false;
        },
    },

    methods: {
        // Note #1: Allows actualizing editItem refs at any time,
        // e.g. on detail open or when switching between tabs,
        // without marking editItem as dirty
        // Note #2: Not ideally implemented, might theoretically
        // obscure actual editItem changes occuring at the same time
        // (if there were any)
        actualizeRefSkipDirty(baseCollName, item, refName) {
            this.withSkipDirty(() => $.actualizeRefOnDemand(baseCollName, item, refName));
        },
        withSkipDirty(fn) {
            if (this.$refs.detail) {
                this.$refs.detail.skipDirty = true;
            }

            fn();

            if (this.$refs.detail) {
                this.$nextTick(() => {
                    if (this.$refs.detail) {
                        this.$refs.detail.skipDirty = false;
                    }
                });
            }
        },
        compoundFilter(item) {
            return (
                (!this.filterFn || this.filterFn(item)) &&
                (!this.archivedFilter || this.archivedFilter(item)) &&
                (!this.finalTextFilter || this.finalTextFilter(item, this.filterText))
            );
        },
        onDetailInit(...args) {
            this.$emit('detail-init', ...args);
        },
        onDetailClosing(...args) {
            this.$emit('detail-closing', ...args);
        },
        onCreate(item) {
            this.$emit('create', item);

            if (this.collName === 'clients' ||
                (this.collName === 'cases' && item.contract?.generated)) {

                $.goToDetail(this.$route.name, item.id);
            } else {
                $.goToMaster();
            }
        },
        onUpdate(item) {
            this.$emit('update', item);

            if (this.collName !== 'cases') {
                $.goToMaster();
            }
        },
        onArchive(item) {
            this.$emit('archive', item);

            $.goToMaster();
        },
        onRestore(item) {
            this.$emit('restore', item);

            $.goToMaster();
        },
        onDestroy(item) {
            this.$emit('destroy', item);

            $.goToMaster();
        },
        onHide() {
            // Reset selected tab on detail close - hacky, but it works
            if (this.$parent.tab) {
                this.$parent.tab = "1";
            }

            // Reset current step on detail close - hacky, but it works
            if (this.$parent.step) {
                this.$parent.step = "1";
            }

            this.$emit('detail-close');
        },
    },
};
